import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';

import { ClaimsService } from '../core/services';

import { UserService } from './users.service';

import { DropdownValue } from '../shared/dropdown.model';

import { PageSizeSelectionComponent } from '../shared/page-size-selection.component';
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";

@Component({
    moduleId: module.id,
    templateUrl: 'users.component.html'
})
export class UsersComponent implements OnInit, AfterViewInit, OnDestroy {
    data: Observable<any[]>;
    pageNumber: number = 1;
    totalCount: number;
    pageSize: number = 0;
    addAllSelectionForUserTypes: boolean = true;
    defaultUserTypeSelection: DropdownValue;
    userId: number = 0;
    private sortFieldId: number = 1;
    private sortDirectionAsc: boolean = true;
    private firstNameFilter: string = '';
    private lastNameFilter: string = '';
    private emailFilter: string = '';
    private userType: number = null;
    filterFirstName = new FormControl();
    filterLastName = new FormControl();
    filterEmail = new FormControl();
    sortFirstNameDir = '#sort';
    sortLastNameDir = '#sort';
    sortEmailDir = '#sort';
    sortUserTypeDir = '#sort';
    useLightClass: boolean = true;
    showOverlay: boolean = true;
    private inXhrGetUsers: any;

    @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent

    constructor(private userService: UserService, private claimsService: ClaimsService, 
        private scrollService: CustomHorizontalScrollService) {
    }

    ngOnInit() {
        this.filterFirstName.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe((filter: string) => {
                this.firstNameFilter = filter.trim();
                this.getPage(1);
            });

        this.filterLastName.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe((filter: string) => {
                this.lastNameFilter = filter.trim();
                this.getPage(1);
            });

        this.filterEmail.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe((filter: string) => {
                this.emailFilter = filter.trim();
                this.getPage(1);
            });
        this.userId = this.claimsService.getUserId();
    }

    ngOnDestroy() {
        if (this.inXhrGetUsers) {
            this.inXhrGetUsers.unsubscribe();
        }
        this.scrollService.toggleHorizontalScroll(false);
    }

    ngAfterViewInit() {
        this.defaultUserTypeSelection = new DropdownValue(0, 'All');
        this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
        this.getPage(1);
        this.sortFieldIcons(1, true);

        // tree select init
        $("#publishers-select-assignement").treeMultiselect({ enableSelectAll: true, sortable: false });
    }

    onResize(event) {
        this.toggleHorizontalScroll();
    }
    
    private toggleHorizontalScroll() {
        let self = this;
        setTimeout(function() {
            self.scrollService.toggleHorizontalScroll();            
        }, 10);
    }

    getPage(page: number) {
        if (this.inXhrGetUsers) {
            this.inXhrGetUsers.unsubscribe();
        }
        this.inXhrGetUsers = this.userService.getUsers(this.sortFieldId, this.sortDirectionAsc, page, this.pageSize, this.firstNameFilter, this.lastNameFilter, this.emailFilter, this.userType)
            .subscribe((res: any) => {
                this.totalCount = res.json().total;
                this.pageNumber = page;
                this.data = res.json().data
            }, null, () => {
                this.showOverlay = false;
                this.toggleHorizontalScroll();
            });
    }

    onPageSizeChanged(item: DropdownValue) {
        this.pageSize = item.value;
        this.pageNumber = 1;
        this.getPage(this.pageNumber);
    }

    onUserChanged() {
        this.getPage(this.pageNumber);
    }

    onDeleteUser(event, userId: number) {
        if (confirm('Are you sure you want to delete this item?')) {
            event.preventDefault();
            event.stopPropagation();
            this.userService.deleteUser(userId).subscribe(() => {
                this.getPage(this.pageNumber);
            });
        }
    }

    onCreateUserClick() {
        $('#userModal').modal('show');
    }

    onSortChanged(fieldId: number) {
        if (this.sortFieldId === fieldId) {
            this.sortDirectionAsc = !this.sortDirectionAsc;
        }
        else {
            this.sortFieldId = fieldId;
            this.sortDirectionAsc = true;
        }

        this.sortFieldIcons(this.sortFieldId, this.sortDirectionAsc);
        this.getPage(this.pageNumber);
    }

    onUserTypeChanged(item) {
        if (item.value === 0)
            this.userType = null;
        else
            this.userType = item.value;
        this.getPage(1);
    }

    onUserTypeClicked(event) {
        $(".configurable-dropdown .list").css("left", function() {
            return $(this).parent().position().left;
          });
        $(".configurable-dropdown .list").css("top", function() {
            return $(this).parent().position().top;
        });
    }

    private sortFieldIcons(sortFieldId: number, asc: boolean) {
        this.sortFirstNameDir = '#sort';
        this.sortLastNameDir = '#sort';
        this.sortEmailDir = '#sort';
        this.sortUserTypeDir = '#sort';
        let iconSufix = 'down';
        if (asc)
            iconSufix = 'up';

        switch (sortFieldId) {
            case 1: this.sortFirstNameDir = this.sortFirstNameDir + '_' + iconSufix; break;
            case 2: this.sortLastNameDir = this.sortLastNameDir + '_' + iconSufix; break;
            case 3: this.sortEmailDir = this.sortEmailDir + '_' + iconSufix; break;
            case 4: this.sortUserTypeDir = this.sortUserTypeDir + '_' + iconSufix; break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/users/users.component.ts